import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { push } from 'react-router-redux';
import { AnyAction } from 'redux';
import { SubscriptionType } from 'common/constants/subscription';
import { ConfirmationDialog } from 'components/dialog/confirmation-dialog';
import { AppUrls } from 'routes/index';

export const CANT_SELECT_PLAN_DIALOG = 'CANT_SELECT_PLAN_DIALOG';

interface Props {
  goTo: (path: string) => void;
}

const IndividualPlanDialogInfoComponent: React.FC<Props> = (props) => {
  const goToManageSeats = React.useCallback((): void => {
    props.goTo(AppUrls.subscription.manageCompanySubscription.url({ type: SubscriptionType.Modular }));
  }, [props.goTo]);

  return (
    <ConfirmationDialog
      name={CANT_SELECT_PLAN_DIALOG}
      title={`Selected plan is for Individual users only`}
      text={`Remove all seats and guests or select another plan, please`}
      confirmButtonText='Manage Seats'
      onConfirm={goToManageSeats}
      cancelButtonText='Cancel'
    />
  );
};


function mapDispatchToProps(dispatch: Dispatch<AnyAction>): Props {
  return {
    goTo: path => dispatch(push(path)),

  };
}

const connector = connect(null, mapDispatchToProps);
export const IndividualPlanDialogInfo = connector(IndividualPlanDialogInfoComponent);
